<template>
  <div class="info-region-container">
    <div class="all-content-container">
      <div class="container1">
        <div class="titlemaun">
          <div class="div-h3">
            <h3>添加环境模型</h3>
          </div>

        </div>
        <div class="div-step">
          <el-steps :active="0" align-center>
            <el-step title="添加环境模型"></el-step>
            <el-step title="添加环境参数"></el-step>
            <el-step title="环境传感器"></el-step>
            <el-step title="执行控制器"></el-step>
            <!--    <el-step title="阶段控制参数"></el-step> -->
          </el-steps>
        </div>
      </div>
      <div class="container1">
        <div class="info-content-container">
          <div class="table_content1" style="margin-top: 10px">
            <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="分组名称：" prop="groupIdArr">
                    <el-cascader expand-trigger="hover" v-model="ruleForm.groupIdArr" :options="groupArray" :props="optionProps" @change="groupChange" placeholder="请选择分组名称" collapse-tags clearable></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="环境模型名称：" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入环境模型名称" maxlength="50" show-word-limit clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="display: flex;justify-content: space-around;">
              <div></div>

              <div slot="footer" class="div-footer">
                <el-button type="primary" @click="handleSave">保 存</el-button>
              </div>
              <div>
                <el-button type="primary" @click="handleNext">下一步</el-button>
                <el-button type="primary" @click="handleReturn">返回环境模型</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        // 添加、编辑弹窗表单
        id: '',
        groupIdArr: [],
        groupId: '',
        name: ''
      },
      rules: {
        // 添加、编辑弹窗表单规则
        groupIdArr: [
          {
            required: true,
            message: '请选择分组名称',
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入模型名称',
            trigger: 'blur'
          }
        ]
      },
      groupArray: [], // 分组名称数组
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      }
    }
  },
  created() {
    this.ruleForm.id = this.$route.query.evnId

    // 获取分组列表
    this.getGroupList()

    // 获取详情
    setTimeout(() => {
      this.getDetail()
    }, 500)
  },
  methods: {
    // 获取详情
    getDetail() {
      if (!this.ruleForm.id || this.ruleForm.id == '') {
        return
      }

      this.$api.growthModel.getGrowthModelEvn({ id: this.ruleForm.id }).then((res) => {
        if (res.code == 200) {
          this.ruleForm = res.data
          this.ruleForm.groupIdArr = [this.getParentGroupId(res.data.groupId), res.data.groupId]
        }
      })
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$api.growthModel.saveGrowthModelEvn(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.ruleForm.id = res.data.evnId
              this.$message({
                type: 'success',
                message: res.msg
              })
            }
          })
        }
      })
    },
    // 分组下拉切换
    groupChange() {
      // 不是三级分类
      if (this.ruleForm.groupIdArr.length !== 2) {
        this.ruleForm.groupIdArr = []
        return
      }
      this.ruleForm.groupId = this.ruleForm.groupIdArr[1]
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then((res) => {
        if (res.code == 200) {
          this.groupArray = res.data
        }
      })
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0
      let children = []
      this.groupArray.map((item) => {
        if (item.children) {
          children = item.children
          let isEnd = false
          children.every(function (val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId
              isEnd = true
            }
            return val2.id != groupId
          })
          return !isEnd
        }
      })

      return parentGroupId
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `growthModel`,
        query: {
          currentShow: 'second'
        }
      })
    },
    // 下一步
    handleNext() {
      if (this.ruleForm.groupId == '') {
        this.$message({
          type: 'error',
          message: '请先添加环境模型'
        })
        return
      }

      this.$router.push({
        name: `addEvnParam`,
        query: {
          evnId: this.ruleForm.id,
          groupId: this.ruleForm.groupId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.all-content-container {
  margin: 0 auto;
  width: 100%;
  margin-top: 10px;

  .container1 {
    border: 1px solid rgba(232, 232, 232, 1);
    margin-top: 10px;
  }

  .div-h3 {
    padding: 15px;
  }

  .div-button {
    margin-top: 10px;
    margin-right: 10px;
  }

  .div-step {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .div-footer {
    text-align: center;
    margin-bottom: 50px;
  }

  .titlemaun {
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid #ededed;
  }
}

.demo-ruleForm {
  width: 600px;
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 30px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>